"use strict";
// Parameter Validation for Cloud Function callbacks
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStr = isStr;
exports.isID = isID;
exports.isCurrentUser = isCurrentUser;
exports.isBoolProp = isBoolProp;
exports.isNumProp = isNumProp;
exports.isStrProp = isStrProp;
exports.isObjectWithProperties = isObjectWithProperties;
function isStr(ctx, s, maxlen) {
    if (typeof s !== 'string') {
        throw ctx.newError('validation: expected string type, got', typeof s);
    }
    if (s === '') {
        throw ctx.newError('validation: expected non-empty string');
    }
    if (s.length > maxlen) {
        throw ctx.newError('validation: expected string shorter than', maxlen, 'got', s.length);
    }
}
function isID(ctx, s) {
    return isStr(ctx, s, 128);
}
function isCurrentUser(ctx, auth, id) {
    const curr = auth.currentUser();
    if (!curr) {
        throw ctx.newError('validation: no current user, so given users cannot be current user');
    }
    else {
        if (curr.uid() !== id) {
            throw ctx.newError(`validation: actual current user "${curr.uid()}" but received user "${id}"`);
        }
    }
}
function isBoolProp(ctx, obj, prop) {
    if (!(prop in obj)) {
        throw ctx.newError(`Expected property "${prop}" on object, not present`);
    }
    const actualT = typeof obj[prop];
    if (actualT !== 'boolean') {
        throw ctx.newError(`Expected boolean for "${prop}" got type "${actualT}"`);
    }
}
function isNumProp(ctx, obj, prop, min, max) {
    if (!(prop in obj)) {
        throw ctx.newError(`Expected property "${prop}" on object, not present`);
    }
    const val = obj[prop];
    if (typeof val !== 'number') {
        throw ctx.newError(`Expected number for "${prop}" got type "${typeof val}"`);
    }
    if ((val < min) || (val > max)) {
        throw ctx.newError(`Expected number for "${prop}" within range [${min}..${max}] but got ${val}`);
    }
}
function isStrProp(ctx, obj, prop, maxlen) {
    if (!(prop in obj)) {
        throw ctx.newError(`Expected property "${prop}" on object, not present`);
    }
    const val = obj[prop];
    if (typeof val !== 'string') {
        throw ctx.newError(`Expected string for "${prop}" got type "${typeof val}"`);
    }
    if (val.length > maxlen) {
        throw ctx.newError(`Expected string for "${prop}" to be less than ${maxlen} but got ${val.length}`);
    }
}
function isObjectWithProperties(ctx, obj, allowedProps) {
    if (typeof obj !== 'object') {
        throw ctx.newError('obj not an object');
    }
    if (obj === null) {
        throw ctx.newError('obj null');
    }
    if (Array.isArray(obj)) {
        throw ctx.newError('obj is an Array');
    }
    const keys = Object.keys(obj);
    if (keys.length > 9) {
        throw ctx.newError('obj has too many keys:' + keys.length);
    }
    const validKeys = new Set(allowedProps);
    // No extra properties allowed
    for (const k of keys) {
        if (!validKeys.has(k)) {
            throw ctx.newError(`Unexpected field "${k}" on object`);
        }
    }
}
//# sourceMappingURL=ParamValidation.js.map